<template>
  <q-page padding>
    <PageHeader title="Editar Usuário" />

    <section
      class="row q-mt-md q-gutter-sm text-brand-5 text-weight-bold inputs-container"
    >
      <div class="col-md col-xs-12 input-item">
        <div>Nome</div>
        <q-input
          dense
          outlined
          :rules="[(val) => val != '' || 'Campo Obrigatório']"
          v-model="user.name"
        />
      </div>
      <div class="col-md col-xs-12 input-item">
        <div>Email</div>
        <q-input
          dense
          outlined
          :rules="[(val) => val != '' || 'Campo Obrigatório']"
          v-model="user.email"
        />
      </div>
      <div class="col-md col-xs-12 input-item">
        <div>ID Usuário</div>
        <q-input
          dense
          outlined
          :rules="[(val) => val != '' || 'Campo Obrigatório']"
          v-model="user.sap"
        />
      </div>
      <div class="col-md col-xs-12 input-item">
        <div>Matricula</div>
        <q-input
          dense
          outlined
          :rules="[(val) => val != '' || 'Campo Obrigatório']"
          v-model="user.tnumber"
        />
      </div>
      <div class="col-md col-xs-12 input-item">
        <div>COD Integração</div>
        <q-input
          dense
          :disable="true"
          outlined
          :rules="[(val) => val != '' || 'Campo Obrigatório']"
          v-model="user.codigo_integracao"
        />
      </div>
    </section>
    <section
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold inputs-container-2"
    >
      <div class="col-md col-xs-12 input-item">
        <div>Data Admissão</div>
        <q-input
          dense
          outlined
          v-model="user.admission_date"
          mask="##/##/####"
          fill-mask
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="user.admission_date"
                  :options="optionsDate"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md col-xs-12 input-item">
        <div>Cargo</div>
        <q-input
          dense
          outlined
          :rules="[(val) => val != '' || 'Campo Obrigatório']"
          v-model="user.cargo"
        />
      </div>
      <div class="col-md col-xs-12 input-item">
        <div>Turno {{ user.vendor_shift_id }}</div>
        <q-select
          outlined
          dense
          map-options
          emit-value
          option-value="id"
          option-label="description"
          v-model="user.vendor_shift_id"
          :options="optionsTurno"
        >
          <template v-slot:selected-item="scope">
            <span v-if="scope.opt.description"
              >{{ scope.opt.description }} - {{ scope.opt.start_time }} /
              {{ scope.opt.finish_time }}</span
            >
          </template>
        </q-select>
      </div>
      <div
        v-if="
          !$store.state.autenticacao.cliente.includes('vale-epiexpress') &&
          !$store.state.autenticacao.cliente.includes('staging-vale')
        "
        class="col-md col-xs-12 input-item"
      >
        <div>Perfil</div>
        <q-select
          outlined
          dense
          v-model="user.roles"
          :options="cargos"
          :option-label="
            (opt) => (Object(opt) === opt && 'name' in opt ? opt.name : '')
          "
          @update:model-value="atribuirPerfil"
        >
          <template v-slot:append>
            <q-btn
              flat
              round
              color="negative"
              icon="sym_o_close"
              size="md"
              :disable="!user.roles || !user.roles.id"
              @click.stop="removerPerfilDialog = true"
            >
              <q-tooltip>Remover Perfil</q-tooltip>
            </q-btn>
          </template>
        </q-select>
      </div>
      <div class="col-md col-xs-12 input-item">
        <div>
          Centro de Custo EPI<q-icon
            style="cursor: pointer"
            class="q-ml-xs"
            name="edit"
            size="20px"
            @click="rightDrawerOpen = true"
          />
        </div>
        <q-select
          outlined
          dense
          disable
          v-model="user.cost_center"
          :options="centros"
          :option-label="
            (opt) => (Object(opt) === opt && 'name' in opt ? opt.name : '')
          "
        >
          <template v-slot:selected-item="scope">
            <div class="tooltip-wrapper ellipsis-text">
              <q-tooltip>
                {{ scope?.opt?.name }} - {{ scope?.opt?.vendor?.name }}
              </q-tooltip>
              {{ scope?.opt?.name }} - {{ scope?.opt?.vendor?.name }}
            </div>
          </template>
        </q-select>
      </div>
    </section>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold botoes-ghe-container q-mt-md"
    >
      <div class="col-md-4 col-xs-12 input-item">
        <div>
          Função / Processo / GHE<q-icon
            style="cursor: pointer"
            class="q-ml-xs"
            name="edit"
            size="20px"
            @click="rightDrawerOpenFuncoes = true"
          />
        </div>

        <q-select
          outlined
          dense
          v-model="gheDados"
          :options="funcoes"
          option-value="id"
          behavior="menu"
          disable
          map-options
          use-input
          option-label="name"
          @filter="filtrarGhe"
        >
          <template v-slot:selected-item="scope">
            <span>{{ scope?.opt?.name }} - {{ scope.opt?.vendor?.name }}</span>
          </template>
        </q-select>
      </div>
      <div class="botoes-acoes">
        <q-btn
          style="margin-top: 22px"
          class="botao-acao"
          color="positive"
          label="Atualizar Informações"
          @click="atualizarUsuario"
          icon="save"
          no-caps
        />
        <q-btn
          style="margin-top: 22px"
          color="secondary"
          class="botao-acao"
          label="Indexar regras"
          @click="indexarRegras"
          icon="refresh"
          no-caps
        />
      </div>
    </div>
    <dialog-info-design
      mensagem="Remover GHE?"
      subMensagem="Tem certeza que deseja remover o GHE do colaborador?"
      :exibir="removerGheDialog"
      :showCancelar="true"
      @resultado="removerGheUsuario"
    >
    </dialog-info-design>
    <dialog-info-design
      mensagem="Remover Perfil?"
      subMensagem="Tem certeza que deseja remover o perfil do usuário?"
      :exibir="removerPerfilDialog"
      :showCancelar="true"
      @resultado="removerPerfilUsuario"
    >
    </dialog-info-design>
    <ModalInformacoesAdicionais
      :rightDrawerOpen="rightDrawerOpen"
      :nomeModal="'Centro de Custo'"
      :tipoModal="'scroll'"
      @fecharModal="rightDrawerOpen = false"
    >
      <template v-slot:conteudo-modal>
        <div class="col-12">
          <div>Unidade</div>
          <SelecaoUnidade
            :model="$store.state.org.unidadeData"
            @enviarUnidade="receberUnidade"
          />
        </div>
        <div class="col-12 q-mt-md">
          <div>Lista Centro de Custos</div>
          <div class="q-mt-sm">
            <div class="row col-12 justify-end">
              <q-input v-model="filtroCentroCusto" dense outlined rounded>
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
            <q-linear-progress v-if="loadingCentro" indeterminate size="3px" />
            <div v-for="(centro, index) in centros" :key="index">
              <div
                style="border: 1px solid; border-radius: 5px"
                class="row col-12 items-center q-mt-xs modal-item"
              >
                <q-radio v-model="centroCustoId" :val="centro.id" />
                <div class="col">
                  <span class="row col-12 modal-text"
                    >Código: {{ centro.code }}</span
                  >
                  <span class="row col-12 modal-text"
                    >Nome: {{ centro.name }}</span
                  >
                </div>
              </div>
            </div>
            <div v-if="centros.length > 0" class="row justify-center q-mt-xs">
              <q-pagination
                :disable="disable"
                v-model="pagination.page"
                color="brand-5"
                active-color="secondary"
                active-text-color="white"
                :max="pagesNumber"
                :max-pages="5"
                :boundary-numbers="false"
                :direction-links="true"
                size="sm"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:botao-modal>
        <q-btn
          no-caps
          icon="done"
          label="Salvar"
          color="positive"
          @click="atualizarUsuario()"
        />
      </template>
    </ModalInformacoesAdicionais>
    <ModalInformacoesAdicionais
      :rightDrawerOpen="rightDrawerOpenFuncoes"
      :nomeModal="'Função / Processo / GHE'"
      :tipoModal="'scroll'"
      @fecharModal="rightDrawerOpenFuncoes = false"
    >
      <template v-slot:conteudo-modal>
        <div class="col-12">
          <div>Unidade</div>
          <SelecaoUnidade
            :model="$store.state.org.unidadeData"
            @enviarUnidade="receberUnidadeFuncoes"
          />
        </div>
        <div class="col-12 q-mt-md">
          <div>Lista de Funções</div>
          <div class="q-mt-sm">
            <div class="row col-12 justify-between">
              <q-btn
                no-caps
                icon="done"
                label="Remover GHE"
                flat
                :disable="gheDados == ''"
                color="negative"
                @click="removerGheDialog = !removerGheDialog"
              />
              <q-input v-model="filtroFuncoes" dense outlined rounded>
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
            <q-linear-progress v-if="loadingFuncoes" indeterminate size="3px" />
            <div v-for="(funcao, index) in funcoes" :key="index">
              <div
                style="border: 1px solid; border-radius: 5px"
                class="row col-12 items-center q-mt-xs modal-item"
              >
                <q-radio v-model="funcaoId" :val="funcao.id" />
                <div class="col">
                  <span class="row col-12 modal-text"
                    >Nome: {{ funcao.name }}</span
                  >
                </div>
              </div>
            </div>
            <div v-if="funcoes.length > 0" class="row justify-center q-mt-xs">
              <q-pagination
                :disable="disable"
                v-model="paginationFuncoes.page"
                color="brand-5"
                active-color="secondary"
                active-text-color="white"
                :max="pagesNumberFuncoes"
                :max-pages="5"
                :boundary-numbers="false"
                :direction-links="true"
                size="sm"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:botao-modal>
        <q-btn
          no-caps
          icon="done"
          label="Salvar"
          color="positive"
          @click="atualizarUsuario()"
        />
      </template>
    </ModalInformacoesAdicionais>
    <cracha :id="id" />
    <tabs-centros-unidades />
    <tabs-tabela-general />
    <div
      v-if="rightDrawerOpen || rightDrawerOpenFuncoes"
      @click="(rightDrawerOpen = false), (rightDrawerOpenFuncoes = false)"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { ref, onBeforeMount, watch, computed } from "vue";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import { useStore } from "vuex";

import Cracha from "../components/CrachaComponent.vue";
import TabsCentrosUnidades from "../components/TabsCentrosUnidades.vue";
import TabsTabelaGeneral from "../components/TabsTabelaGeneral.vue";
import ModalInformacoesAdicionais from "../../../requisicao/components/ModalInformacaoesAdicionais";
import SelecaoUnidade from "../../../ferramentaria/components/SelecaoUnidade.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: {
    Cracha,
    TabsCentrosUnidades,
    TabsTabelaGeneral,
    ModalInformacoesAdicionais,
    SelecaoUnidade,
    DialogInfoDesign,
    PageHeader,
  },
  setup() {
    const user = ref("");
    const store = useStore();
    const route = useRoute();
    const id = route.params.id;
    const cargos = ref([]);
    const funcoes = ref([]);
    const centros = ref([]);
    const $q = useQuasar();
    const filtroCentroCusto = ref("");
    const role = ref("");
    const gheDados = ref("");
    const optionsTurno = ref([]);
    const removerGheDialog = ref(false);
    const removerPerfilDialog = ref(false);
    const unidadeFiltro = ref({
      centroCusto: "",
      funcoes: "",
    });
    const rightDrawerOpen = ref(false);
    const rightDrawerOpenFuncoes = ref(false);
    const centroCustoId = ref("");
    const tenentsPorRole = ref(["starrett", "dexco"]);
    const loadingCentro = ref(false);
    const disable = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 6,
    });
    const paginationFuncoes = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 6,
    });
    const funcaoId = ref("");
    const filtroFuncoes = ref("");
    const loadingFuncoes = ref(false);

    const getUser = async () => {
      gheDados.value = "";
      let response = await store.dispatch("user/getUserEspecifico", {
        id,
      });
      user.value = response.data.model;
      user.value.cost_center = response.data.model.cost_center;
      user.value.staticRole = response.data.model.roles[0];
      user.value.roles = response.data.model.roles[0];
      if (response.data.model.function_model != null) {
        user.value.function_model = response.data.model.function_model;
        gheDados.value = { ...user.value.function_model };
        funcaoId.value = gheDados.value?.id;
      }
      user.value.admission_date = response.data.model.admission_date
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");
      centroCustoId.value = user.value?.cost_center?.id;
    };

    const getRoles = async () => {
      const perfisBloqueados = ["admin", "tablet", "sistema"];
      let response = await store.dispatch("user/getRoles");
      cargos.value = response.data.results.data.filter(
        (value) => !perfisBloqueados.includes(value.name)
      );
    };

    const getFunctions = async (page = 1, perPage = 10) => {
      try {
        loadingFuncoes.value = true;
        disable.value = true;
        const response = await store.dispatch("user/getFuncoes", {
          vendor_id: unidadeFiltro.value.funcoes?.id,
          search: filtroFuncoes.value,
          page,
          per_page: perPage,
        });

        funcoes.value = response.data.results.data;
        paginationFuncoes.value.page = response.data.results.current_page;
        paginationFuncoes.value.perPage = response.data.results.per_page;
        paginationFuncoes.value.rowsNumber = response.data.results.total;
        loadingFuncoes.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
        loadingFuncoes.value = false;
        disable.value = false;
      }
    };

    const getCentros = async (page = 1, perPage = 10) => {
      try {
        disable.value = true;
        loadingCentro.value = true;
        let response = await store.dispatch("user/getCentros", {
          vendor_id: unidadeFiltro.value.centroCusto?.id,
          page,
          per_page: perPage,
          search: filtroCentroCusto.value,
        });

        centros.value = response.data.results.data;
        pagination.value.page = response.data.results.current_page;
        pagination.value.perPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        loadingCentro.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
      }
    };

    const getTurnos = async () => {
      try {
        disable.value = true;
        loadingCentro.value = true;
        let response = await store.dispatch("user/getTurnos", {
          vendor_id: unidadeFiltro.value.centroCusto?.id,
        });

        optionsTurno.value = response.data.results;

        loadingCentro.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
      }
    };

    const atualizarUsuario = async () => {
      console.log();
      if (tenentsPorRole.value.includes(store.state.autenticacao.cliente[0])) {
        if (
          store.state.autenticacao.usuarioLogado.roleLevel >=
          user.value?.roles?.id
        ) {
          $q.notify({
            message:
              "Você não pode editar um usuário com perfil maior que o seu",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
      }

      try {
        await store.dispatch("user/editarUser", {
          user: user.value,
          vendor_shift_id: user.value.vendor_shift_id
            ? user.value.vendor_shift_id
            : undefined,
          roles: user.value.roles ? user.value.roles.id : undefined,
          cost_center_id: centroCustoId.value ? centroCustoId.value : undefined,
          function_id: funcaoId.value,
          email: user.value.email ? user.value.email : undefined,
        });

        $q.notify({
          message: "Dados atualizados com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        setRole();
        rightDrawerOpen.value = false;
        rightDrawerOpenFuncoes.value = false;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o atualizar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const setRole = async () => {
      await store.dispatch("user/editarRoles", {
        user: user.value,
        roles: user.value.roles.id,
      });

      getUser();
    };

    const indexarRegras = async () => {
      try {
        await store.dispatch("user/indexarRegras", {
          usuarios: [+id],
        });
        getUser();
        $q.notify({
          message:
            "Job de re-indexação disparado, as atualizações serão feitas em background",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o indexar regras",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const removerGheUsuario = async (resultado) => {
      removerGheDialog.value = false;
      if (resultado) {
        try {
          await store.dispatch("user/removerGheUsuario", {
            userId: id,
          });
          getUser();
          $q.notify({
            message: "Funcão/Processo/GHE removido com sucesso.",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          gheDados.value = "";
        } catch (error) {
          $q.notify({
            message: "Erro ao remover Funcão/Processo/GHE.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const removerPerfilUsuario = async (resultado) => {
      removerPerfilDialog.value = false;
      if (resultado) {
        try {
          if (!user.value.roles || !user.value.roles.id) {
            $q.notify({
              message: "Usuário não possui perfil para remover.",
              color: "warning",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            return;
          }

          await store.dispatch("user/removerPerfil", {
            user_id: id,
            roles: [user.value.roles.id],
          });

          getUser();
          $q.notify({
            message: "Perfil removido com sucesso.",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          console.log(error);
          $q.notify({
            message: "Erro ao remover perfil.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const verificarFormatoData = (dataString) => {
      const formatoEsperado = /^\d{4}-\d{2}-\d{2}$/;

      return formatoEsperado.test(dataString);
    };

    const receberUnidade = (value) => {
      unidadeFiltro.value.centroCusto = value;
      getCentros();
    };

    const receberUnidadeFuncoes = (value) => {
      unidadeFiltro.value.funcoes = value;
      getFunctions();
    };

    const atribuirPerfil = async (newValue) => {
      if (newValue) {
        await atualizarUsuario();
      }
    };

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        getFunctions();
        getCentros();
      }
    );

    watch(
      () => filtroCentroCusto.value,
      () => {
        getCentros();
      }
    );

    watch(
      () => filtroFuncoes.value,
      () => {
        getFunctions();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        getCentros(pagination.value.page, pagination.value.perPage);
      }
    );

    watch(
      () => paginationFuncoes.value.page,
      () => {
        getFunctions(
          paginationFuncoes.value.page,
          paginationFuncoes.value.perPage
        );
      }
    );

    watch(
      () => gheDados.value,
      () => {
        if (
          gheDados.value != "" &&
          gheDados.value?.id != user.value?.function_model?.id
        ) {
          atualizarUsuario();
        }
      }
    );

    onBeforeMount(getUser);
    onBeforeMount(getRoles);
    onBeforeMount(getFunctions);
    onBeforeMount(getTurnos);

    return {
      getUser,
      user,
      atualizarUsuario,
      getFunctions,
      optionsTurno,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      cargos,
      funcoes,
      centros,
      receberUnidade,
      unidadeFiltro,
      receberUnidadeFuncoes,
      rightDrawerOpenFuncoes,
      filtroFuncoes,
      role,
      filtrarGhe(val, update) {
        getFunctions(val);
        setTimeout(() => {
          update();
        }, 500);
      },
      id,
      gheDados,
      rightDrawerOpen,
      filtroCentroCusto,
      removerGheUsuario,
      removerGheDialog,
      removerPerfilUsuario,
      removerPerfilDialog,
      verificarFormatoData,
      loadingCentro,
      indexarRegras,
      centroCustoId,
      pagination,
      disable,
      funcaoId,
      loadingFuncoes,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      paginationFuncoes,
      pagesNumberFuncoes: computed(() =>
        Math.ceil(
          paginationFuncoes.value.rowsNumber /
            paginationFuncoes.value.rowsPerPage
        )
      ),
      optionsDate(date) {
        const atualDate = new Date()
          .toLocaleString("pt-br")
          .split(",")[0]
          .split("/")
          .reverse()
          .join("/");
        return date <= atualDate;
      },
      atribuirPerfil,
    };
  },
};
</script>

<style scoped>
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.tooltip-wrapper {
  pointer-events: auto; /* Reativa eventos do mouse */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: inline-block;
}

.inputs-container {
  flex-direction: row;
}

.inputs-container-2 {
  flex-direction: row;
}

.botoes-ghe-container {
  flex-direction: row;
}

.botoes-acoes {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.botao-acao {
  margin-left: 8px;
}

@media (max-width: 600px) {
  .text-h6 {
    font-size: 1.2rem !important;
    text-align: center;
    margin-bottom: 16px;
  }

  .q-page {
    padding: 12px !important;
  }

  .inputs-container {
    flex-direction: column !important;
    gap: 0 !important;
  }

  .inputs-container-2 {
    flex-direction: column !important;
    gap: 0 !important;
    margin-top: 16px !important;
  }

  .input-item {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin: 0 0 16px 0 !important;
  }

  .input-item:last-child {
    margin: 0 0 16px 0 !important;
  }

  .input-item .q-field {
    width: 100% !important;
  }

  .botoes-ghe-container {
    flex-direction: column !important;
    gap: 0 !important;
    margin-top: 16px !important;
  }

  .botoes-ghe-container .input-item {
    margin: 0 0 16px 0 !important;
  }

  .botoes-acoes {
    width: 100% !important;
    flex-direction: column !important;
    gap: 12px !important;
    margin-top: 0 !important;
  }

  .botao-acao {
    width: 100% !important;
    margin: 0 !important;
    padding: 12px 16px;
    font-size: 14px;
  }

  .modal-item {
    padding: 12px !important;
    margin-bottom: 8px !important;
  }

  .modal-text {
    font-size: 13px !important;
    line-height: 1.4;
  }

  .q-drawer {
    width: 100% !important;
  }

  .q-pagination {
    font-size: 12px !important;
  }

  .q-pagination .q-btn {
    min-width: 32px !important;
    height: 32px !important;
    font-size: 12px !important;
  }
}

@media (max-width: 390px) {
  .text-h6 {
    font-size: 1.1rem !important;
  }

  .q-page {
    padding: 8px !important;
  }

  .inputs-container-2 {
    margin-top: 12px !important;
  }

  .botoes-ghe-container {
    margin-top: 12px !important;
  }

  .input-item {
    margin: 0 0 12px 0 !important;
  }

  .input-item:last-child {
    margin: 0 0 12px 0 !important;
  }

  .botoes-ghe-container .input-item {
    margin: 0 0 12px 0 !important;
  }

  .botao-acao {
    font-size: 12px !important;
    padding: 10px 12px;
  }

  .modal-text {
    font-size: 12px !important;
  }
}
</style>

<style>
.q-field--outlined.q-field--readonly .q-field__control:before {
  border-style: solid !important;
}
</style>
